export default [
  { routeName: "trainingsCrudEdit", tabTitle: "Datos del curso" },
  { routeName: "trainingsCrud-lessons", tabTitle: "Lecciones" },
];
